// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"747f3cb3","667":"7ec6c1ae","977":"e808494c"}[chunkId] + ".chunk.js";
};